import { logPerformanceEvent as logAriaPerformance } from '@office-start/instrumentation-service';
import { DataSecurityLevel, } from '@office-start/instrumentation-types';
import { logPerformance } from '@office-start/telemetry-service';
export function logPerformanceEvent(name, duration, params, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    logAriaPerformance(name, duration, params, securityThreshold);
    // OTEL logging, should remove above aria logging once OTEL migration complete.
    logPerformance({
        eventName: name,
        latency: duration,
    }, securityThreshold);
}
//# sourceMappingURL=logPerformanceEvent.js.map